import { createClient } from '@supabase/supabase-js';
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY');
}
// Capture URL state BEFORE createClient() — Supabase cleans up the hash/params
// synchronously during construction (implicit flow) or asynchronously (PKCE/token_hash).
// This flag is the only reliable way to know we arrived via a recovery link.
const _p = new URLSearchParams(window.location.search);
export const wasRecoveryCallback = _p.has('code') || // PKCE flow: ?code=xxx
    _p.get('type') === 'recovery' || // token_hash flow: ?type=recovery
    window.location.hash.includes('type=recovery'); // implicit flow: #type=recovery
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
    },
});
